import GameApi from './GameApi';
export default GameApi;